import React from 'react';
import { Router } from '@abyss/web/ui/Router';
import { Login } from '@src/components/public/Login';
import { SingleSignOn } from '@src/components/public/SingleSignOn/SingleSignOn';
import { NotFound } from '@src/components/public/NotFound';
import { Layout } from '@src/components/layouts/v1';
import { SharedLayout } from '@src/components/layouts/SharedLayout';
import { AuthenticationGuard } from './AuthenticationGuard';
import { DataTableExample } from '@src/components/pages/DataTableExample';
import { EmployeeDetail } from '@src/components/pages/EmployeeDetail';
import { ApplyToken } from '@src/components/demo/ApplyToken';
import { SetUser } from '@src/components/demo/SetUser';
import { MigrationSchedulerGrid } from '@src/components/demo/pages/workspace/DeviceMigration/DeviceMigrationGrid/migrationScheduler';
import { ClientGrid } from '@src/components/demo/pages/admin/Client/ClientGrid/clients2';
import { UploadScreen } from '@src/components/pages/RouteTool/Upload';
import { SearchScreen } from '@src/components/pages/RouteTool/Search';
import { MonitorScreen } from '@src/components/pages/RouteTool/Monitor';
import { DashboardScreen } from '@src/components/pages/RouteTool/Dashboard';
import { ResultsScreen } from '@src/components/pages/RouteTool/Results';
import { TemplatesScreen } from '@src/components/pages/RouteTool/Templates';
import { ManageEntityScreen } from '@src/components/pages/RouteTool/ManageEntity';

export const Routes = () => {
  return (
    <Router.Routes title="ACM | {{title}}">
      <Router.Route
        element={
          <AuthenticationGuard requireAuth={true}>
            <Layout />
          </AuthenticationGuard>
        }
      >
        <Router.Route
          path="/datatable-example"
          element={<DataTableExample />}
        />
        <Router.Route path="/employee/:id" element={<EmployeeDetail />} />
        <Router.Route path="/" element={<DashboardScreen />} />
        <Router.Route path="/apply-token" element={<ApplyToken />} />
        <Router.Route path="/set-user" element={<SetUser />} />
        <Router.Route
          path="/device-migration"
          element={<MigrationSchedulerGrid />}
        />
        <Router.Route path="/clients" element={<ClientGrid />} />
        <Router.Route path="/route-tool/upload" element={<UploadScreen />} />
        <Router.Route path="/route-tool/search" element={<SearchScreen />} />
        <Router.Route path="/route-tool/monitor" element={<MonitorScreen />} />
        <Router.Route
          path="/route-tool/add-entity"
          element={<ManageEntityScreen />}
        />
        <Router.Route
          path="/route-tool/templates"
          element={<TemplatesScreen />}
        />
        <Router.Route
          path="/route-tool/results/:id"
          element={<ResultsScreen />}
        />
        <Router.Route
          path="/route-tool/tables/:id"
          element={<ResultsScreen />}
        />
        <Router.Route
          path="/route-tool/maps/:id"
          element={<ResultsScreen />}
        />
      </Router.Route>
      <Router.Route
        element={
          <AuthenticationGuard requireAuth={false}>
            <SharedLayout />
          </AuthenticationGuard>
        }
      >
        <Router.Route path="/login" element={<Login />} />
        <Router.Route path="/sso" element={<SingleSignOn />} />
        <Router.Route path="/getToken" element={<SingleSignOn />} />
        <Router.Route path="/getAToken" element={<SingleSignOn />} />
        <Router.Route path="*" element={<NotFound />} />
      </Router.Route>
    </Router.Routes>
  );
};
